import { cn } from "@design-system/utils";
import React, { useEffect, useState } from "react";

const DEFAULT_DELAY_MS = 100;
const DEFAULT_DURATION_S = 2.5;

interface LoadingBarProps {
  isLoading: boolean;
  delay?: number;
  duration?: number;
}

function LoadingBar({
  isLoading,
  delay = DEFAULT_DELAY_MS,
  duration = DEFAULT_DURATION_S,
}: LoadingBarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timeout = setTimeout(() => setVisible(true), delay);
      return () => clearTimeout(timeout);
    }
    setVisible(false);
  }, [isLoading, delay]);

  return (
    <div
      role="status"
      aria-label="Loading"
      aria-hidden={!visible}
      className={cn(
        "bg-shape-neutral-filled-background absolute inset-x-0 top-0 z-10 h-1 transition-opacity duration-300",
        visible ? "opacity-100" : "opacity-0"
      )}
    >
      <div
        className="via-shape-neutral-inverted-background h-full w-full bg-linear-to-r from-transparent from-25% via-50% to-transparent to-75% bg-[length:200%_100%]"
        style={{ animation: `shimmer-slide ${duration}s linear infinite` }}
      />
    </div>
  );
}

export { LoadingBar };
export type { LoadingBarProps };
